import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AddNewDataModel} from '../model/add-new-data-model';
import {Observable} from 'rxjs';
import {ResponseData} from '../../../core/modal/base-save-update-response';
import {RequestData} from '../../../core/modal/base-save-update-modal';
import {environment} from '../../../../environments/environment';
import {AuthUtilsService} from '../../../core/util/auth-utils.service';

@Injectable({
  providedIn: 'root'
})
export class AddNewService {

  constructor(
      private http: HttpClient,
      private authService: AuthUtilsService
  ) { }

  public save(modal: any, addNewUrlName: string): Observable<ResponseData<any>> {
    return this.http.post<ResponseData<any>>(environment.SERVER_URL + addNewUrlName + '/save', modal);
  }
}
